import { createFileRoute } from "@tanstack/react-router";

import { GroupAdminDigestPanel } from "@/components/groups/group-admin";
import { useGroupRouteData } from "@/hooks/use-group-route-data";

export const Route = createFileRoute("/_authenticated/app/groups/$groupId/admin/digest")({
  component: GroupAdminDigestTab,
});

function GroupAdminDigestTab() {
  const { groupId, isAdmin, group } = useGroupRouteData(Route.useParams().groupId);

  if (!group || !isAdmin) return null;

  return <GroupAdminDigestPanel groupId={groupId} companyId={group.companyId} />;
}
